const selectors = {
  container: '#container-accordion-nearby',
  toggle: '[data-nearby-toggle]',
  content: '[data-nearby-content]',
  tab: '[data-nearby-tab]',
  panel: '[data-nearby-panel]',
  checkbox: '#chk-accordion-nearby'
}

const pushDataLayerEvent = (eventName, elementId) => {
  if (!eventName || !elementId) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: eventName, id: elementId })
}

const setOpenState = ($container, isOpen) => {
  if (!$container.length) return

  const $toggle = $container.find(selectors.toggle)
  const $content = $container.find(selectors.content)
  const $checkbox = $container.find(selectors.checkbox)

  $container.attr('data-open', isOpen ? 'true' : 'false')
  $toggle.attr('aria-expanded', isOpen ? 'true' : 'false')
  $content.attr('aria-hidden', isOpen ? 'false' : 'true')

  if ($checkbox.length) {
    $checkbox.prop('checked', isOpen)
  }
}

const activateTab = ($container, targetTab) => {
  const $tabs = $container.find(selectors.tab)
  const $panels = $container.find(selectors.panel)

  if (!$tabs.length || !$panels.length) return

  $tabs.removeClass('is-active')
  $panels.removeClass('is-active').attr('aria-hidden', 'true')

  const $activeTab = $tabs.filter(`[data-nearby-tab="${targetTab}"]`)
  const $activePanel = $panels.filter(`[data-nearby-panel="${targetTab}"]`)

  if ($activeTab.length) {
    $activeTab.addClass('is-active')
  } else if ($tabs.length) {
    $tabs.eq(0).addClass('is-active')
  }

  if ($activePanel.length) {
    $activePanel.addClass('is-active').attr('aria-hidden', 'false')
  } else if ($panels.length) {
    $panels.eq(0).addClass('is-active').attr('aria-hidden', 'false')
  }
}

const bindAccordionToggle = () => {
  $(document).on('click', `${selectors.container} ${selectors.toggle}`, function () {
    const $container = $(this).closest(selectors.container)
    const isOpen = $container.attr('data-open') !== 'true'
    setOpenState($container, isOpen)
    pushDataLayerEvent(isOpen ? 'open_accordion' : 'close_accordion', 'Card_Proximities')
  })
}

const bindTabSwitch = () => {
  $(document).on('click', `${selectors.container} ${selectors.tab}`, function (event) {
    event.preventDefault()
    event.stopPropagation()

    const $container = $(this).closest(selectors.container)
    const targetTab = $(this).data('nearby-tab')

    activateTab($container, targetTab)
  })
}

const init = () => {
  const $container = $(selectors.container)
  if (!$container.length) return

  $container.each(function () {
    const $current = $(this)
    setOpenState($current, true)
    activateTab($current, 'airports')
  })

  bindAccordionToggle()
  bindTabSwitch()
}

export default {
  init
}
